<script>
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            states: [],

            newState: {
                start_date: null,
                end_date: null,
            },
            
            stateToUpdate: null,

            headers: [
                { key: '#', flex: .2 },
                { key: 'created_by', flex: 1 },
                { key: 'email', flex: 1 },
                { key: 'status', flex: 1 },
                { key: 'start_date', flex: 1 },
                { key: 'end_date', flex: 1 },
            ],
        }
    },

    computed: {

    },

    mounted() {
        this._getAppStates();
    },

    methods: {
        ...mapActions('admin', [
            'getAppStates',
            'createAppState',
            'updateAppState',
            'deleteAppState',
        ]),

        _getAppStates() {
            this.getAppStates()
                .then(res => {
                    this.states = res.data;
                })
        },

        _createAppState() {
            this.createAppState(
                {
                    start_date: this.makeNonTimezoneSensitive(this.newState.start_date),
                    end_date: this.makeNonTimezoneSensitive(this.newState.end_date),
                }
            )
                .then((res) => {
                    this.states.unshift(
                        {
                            ...this.newState,
                            status: 'scheduled',
                            created_by: `${this.$user.firstname} ${this.$user.surname}`,
                            email: this.$user.email
                        }
                    );
                    
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },

        _updateAppState() {
            const params = {
                id: this.stateToUpdate.id,
                body: {
                    start_date: this.stateToUpdate.start_date,
                    end_date: this.stateToUpdate.end_date,
                },
            };
            this.updateAppState(params)
                .then(() => {
                    this.$notify('success', '', true);
                    this.$refs.updatePopup.startHideProcess();
                })
                .catch(() => {
                    this.$notify('error', '', true);
                })
        },

        _deleteAppState() {
            this.deleteAppState({id: this.stateToUpdate.id})
                .then(() => {
                    this.states = this.states.filter(x => x.id != this.stateToUpdate.id);
                    this.$refs.updatePopup.startHideProcess();
                })
                .catch(() => {
                    this.$notify('error', '', true);
                })
        },

        openUpdateModal(state) {
            this.stateToUpdate = {
                ...state,
                start_date: this.reverseTimezoneFromDb(state.start_date),
                end_date: this.reverseTimezoneFromDb(state.end_date),
            };
            this.$refs.updatePopup.openPopup();
        },

        getStatusColor(item) {
            switch (item['status']) {
                case 'scheduled':
                    return 'var(--sustainfinity-blue)'
                case 'downtime':
                    return 'var(--invalid-input)'
                case 'completed':
                    return 'var(--sustainfinity-green)'
                default:
                    return 'gray';
            }
        },

        makeNonTimezoneSensitive(value) {
            const local = new Date(value);
            const utc = new Date(local.getTime() - local.getTimezoneOffset() * 60000);
            return utc.toISOString();
        },

        reverseTimezoneFromDb(value) {
            const local = new Date(value);
            const offset = local.getTimezoneOffset();
            return new Date(local.getTime() - offset * 60000).toISOString().slice(0, 16);
        },
    }
}
</script>

<template>
    <div class="flex-all-centered-col">
        <div class="states-table flex-all-centered-col">
            <div class="header-row flex-all-centered-row">
                <div v-for="header in headers" :key="header.key" 
                    :style="{
                        'flex': header.flex
                    }"
                >
                    <span>{{ $t(`app_state.headers.${header.key}`) }}</span>
                </div>
            </div>
            <div v-for="(state, idx) in states" :key="state.user_id" class="state-row flex-all-centered-row"
                @click="openUpdateModal(state)"
            >
                <div v-for="header in headers" :key="header.key" 
                    :style="{
                        'flex': header.flex
                    }"
                >
                    <div v-if="header.key === '#'">
                        {{ Number(states.length) - idx }}
                    </div>
                    <div v-else-if="header.key === 'status'"
                        :style="{
                            'color': getStatusColor(state),
                            'font-weight': 'bold',
                        }"
                    >
                        {{ $t(`app_state.state.${state['status']}`) }}
                    </div>
                    <div v-else-if="header.key.includes('_date')">
                        {{ state[header.key] | dateFormat }} 
                    </div>
                    <div v-else>
                        {{ state[header.key] }} 
                    </div>
                </div>
            </div>
            <div v-if="states.length === 0" class="state-row flex-all-centered-row"
                style="justify-content: center !important; padding: .5em;"
            >
                {{ $t('app_state.no_state_record') }}
            </div>
        </div>

        <br>
        <button class="sust-btn sust-btn-green" 
            style="align-self: flex-end;"
            @click="() => $refs.createPopup.openPopup()"
        >
            {{ $t('app_state.create') }}
        </button>

        <sust-popup ref="createPopup"
            size="sm"
            :title="$t('app_state.create')"
            @ok="_createAppState()"
            @onHide="() => newState = {
                start_date: null,
                end_date: null,
            }"
        >
            <div class="flex-all-centered-col">
                <div class="flex-all-centered-col">
                    <div style="width: 100%; text-align: center;">
                        {{ $t('app_state.headers.start_date') }}
                    </div>
                    <div>
                        <input v-model="newState.start_date"
                            type="datetime-local"  
                            class="sust-input-field"
                            style="width: 100%;"
                        >
                    </div>
                </div>
                <div class="flex-all-centered-col">
                    <div style="width: 100%; text-align: center;">
                        {{ $t('app_state.headers.end_date') }}
                    </div>
                    <div>
                        <input v-model="newState.end_date"
                            type="datetime-local"  
                            class="sust-input-field"
                            style="width: 100%;"
                        >
                    </div>
                </div>
            </div>
        </sust-popup>

        <sust-popup ref="updatePopup"
            size="sm"
            :title="$t('app_state.update_title')"
            :footer="false"
            @onHide="() => stateToUpdate = null"
        >
            <div v-if="stateToUpdate" class="flex-all-centered-col">
                <div class="flex-all-centered-col">
                    <div style="width: 100%; text-align: center;">
                        {{ $t('app_state.headers.start_date') }}
                    </div>
                    <div>
                        <input v-model="stateToUpdate.start_date"
                            type="datetime-local"  
                            class="sust-input-field"
                            style="width: 100%;"
                        >
                    </div>
                </div>
                <div class="flex-all-centered-col">
                    <div style="width: 100%; text-align: center;">
                        {{ $t('app_state.headers.end_date') }}
                    </div>
                    <div>
                        <input v-model="stateToUpdate.end_date"
                            type="datetime-local"  
                            class="sust-input-field"
                            style="width: 100%;"
                        >
                    </div>
                </div>
                <div class="flex-all-centered-col" style="text-transform: uppercase;">
                    <button class="sust-btn sust-btn-blue"
                        style="margin-top: 1.5em;"
                        @click="_updateAppState()"
                    >
                        {{ $t('app_state.update') }}
                    </button>
                    <button class="sust-btn sust-btn-red"
                        style="margin-top: 1.5em;"
                        @click="_deleteAppState()"
                    >
                        {{ $t('app_state.delete') }}
                    </button>
                </div>
            </div>
        </sust-popup>
    </div>
</template>

<style lang='scss' scoped>
    .states-table {
        border-radius: 1em;
        overflow: hidden !important;
        box-shadow: 0 .25em .5em .1em gray;
    }

    .header-row {
        overflow: hidden !important;
        background-color: var(--sustainfinity-navy);
        color: whitesmoke;
        border-top-left-radius: 1em;
        border-top-right-radius: 1em;

        > div {
            border-right: thin solid whitesmoke;
            &:last-of-type {
                border-right: 0 !important;
            }
        }
    }
    
    .state-row {
        overflow: hidden !important;
        background-color: whitesmoke;
        color: var(--sustainfinity-navy);
        border-bottom: thin solid lightgray;

        cursor: pointer;
        transition: background-color 150ms;
        &:hover {
            background-color: lightgray;
        }

        &:last-of-type {
            border-bottom: 0 !important;
            border-bottom-left-radius: 1em;
            border-bottom-right-radius: 1em;
        }

        > div {
            &:last-of-type {
                border-right: 0 !important;
            }
        }
    }

    .header-row, .state-row {
        justify-content: flex-start;
        align-items: stretch;
        > div {
            padding: 1em;
        }
    }
</style>